<template>
    <div>
        <h5>All Available Permission Groups</h5>
        <div v-if="authStore.hasPermission(UserPermission.WRITE_GROUPS) && !permissionStore.loading" class="card">
            <Button label="Create Permission Group" @click="formDialog = true" />
        </div>
        <!-- Group Form to add new groups or edit existing groups -->
        <group-form v-if="formDialog" @hide-dialog="formDialog = false" />
        <!-- Group Table module -->
        <group-table />
    </div>
</template>

<script setup>
import GroupForm from '../components/GroupForm.vue';
import GroupTable from '../components/GroupTable.vue';
import { ref } from 'vue';
import { UserPermission } from '../../permission/enum';
import { authStore, permissionStore } from '../../../store/global-stores';

const formDialog = ref(false);

</script>
